"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("./styles");
const Badge_1 = require("../Badge");
exports.Box = ({ children, title, subtitle, badgeText, badgeType = 'secondary', className, contentClassName, }) => {
    if (typeof title === "undefined" &&
        typeof subtitle !== "undefined")
        return (react_1.default.createElement(__1.Alert, { type: "danger", message: 'Para utilizar a propriedade "subtitle" do componente "<Box />", defina um "title".' }));
    const boxClassNames = classnames_1.default("box", className);
    contentClassName = classnames_1.default("box-content", contentClassName);
    return (react_1.default.createElement(styles_1.Container, { className: boxClassNames },
        title && (react_1.default.createElement(styles_1.Header, null,
            react_1.default.createElement(styles_1.HeaderText, null,
                react_1.default.createElement(styles_1.Title, null, title),
                subtitle && (react_1.default.createElement(styles_1.Subtitle, null, subtitle))),
            badgeText && (react_1.default.createElement(styles_1.BadgeContainer, null,
                react_1.default.createElement(Badge_1.Badge, { type: badgeType }, badgeText))))),
        react_1.default.createElement(styles_1.Content, { className: contentClassName }, children)));
};
